namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoHdRow {
        PromoId?: string;
        PromoName?: string;
        PromoDesc?: string;
        PromoCampaign?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: PromoTimeFg;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: PromoDayChFg;
        PromoDay?: number[];
        PromoShopFg?: PromoShopFg;
        PromoShop?: string[];
        PromoCustFg?: number;
        PromoMb?: string[];
        PromoApproveFg?: ApprovePromoFgSelect;
        PromoStatus?: PostStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        Id?: number;
        PromoDetailList?: PsPromoDtRow[];
        VenderSharing?: number;
    }

    export namespace PsPromoHdRow {
        export const idProperty = 'PromoId';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'SalePromoCamp.PsPromoHd';
        export const lookupKey = 'SalePromoCamp.PsPromoHd';

        export function getLookup(): Q.Lookup<PsPromoHdRow> {
            return Q.getLookup<PsPromoHdRow>('SalePromoCamp.PsPromoHd');
        }
        export const deletePermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:Delete';
        export const insertPermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:Modify';
        export const readPermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:View';
        export const updatePermission = '1POSBASE:การจัดการราคาโปรโมชั่น:สร้าง:Modify';

        export declare const enum Fields {
            PromoId = "PromoId",
            PromoName = "PromoName",
            PromoDesc = "PromoDesc",
            PromoCampaign = "PromoCampaign",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoMb = "PromoMb",
            PromoApproveFg = "PromoApproveFg",
            PromoStatus = "PromoStatus",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            Id = "Id",
            PromoDetailList = "PromoDetailList",
            VenderSharing = "VenderSharing"
        }
    }
}
